import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

export function Toaster({ id }: Pick<ToasterProps, "id">) {
  return (
    <SonnerToaster
      id={id}
      theme="light"
      position="top-center"
      visibleToasts={1}
      duration={4000}
      offset={16}
      mobileOffset={{
        top: "calc(env(safe-area-inset-top) + 16px)",
        left: 16,
        right: 16,
      }}
      toastOptions={{
        classNames: {
          toast:
            "rounded-xl! border-butter-cream! bg-butter-cream-light! font-sans! text-butter-green! shadow-lg!",
          title: "text-sm! font-normal!",
        },
      }}
    />
  );
}
